import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    catalogueStateKey,
    getCatalogueFiltersLabel
} from '../../helpers/catalogueUtils';

class FiltersLabel extends PureComponent {
    static propTypes = {
        dataTable: PropTypes.object.isRequired,
        refinement: PropTypes.object.isRequired,
        refinementHistory: PropTypes.array.isRequired,
        data: PropTypes.object.isRequired,
        refinementSelector: PropTypes.func.isRequired
    };

    shouldComponentUpdate(nextProps) {
        return this.props.dataTable !== nextProps.dataTable && !nextProps.dataTable.loading;
    }

    render() {
        const { refinement, refinementHistory, data } = this.props;
        return (
            <span
                className="sales__HeaderFilterLabel_text"
                data-test-selector="filters_applied"
            >
                {getCatalogueFiltersLabel({ refinement, refinementHistory, data })}
            </span>
        );
    }
}

const mapStateToProps = (state, { refinementSelector }) => {
    const { dataTable, refinementHistory, data } = state[catalogueStateKey];
    return {
        dataTable,
        refinement: refinementSelector(state[catalogueStateKey]),
        refinementHistory,
        data
    };
};

export default connect(mapStateToProps)(FiltersLabel);



// WEBPACK FOOTER //
// ./src/js/containers/Catalogue/FiltersLabel.js